<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="ID" prop="id">
        <el-input v-model="dataForm.id" placeholder="ID"></el-input>
      </el-form-item>
      <el-form-item label="用户id(老师/学生)" prop="userId">
        <el-input v-model="dataForm.userId" placeholder="用户id(老师/学生)"></el-input>
      </el-form-item>
      <el-form-item label="课程id" prop="courseId">
        <el-input v-model="dataForm.courseId" placeholder="课程id"></el-input>
      </el-form-item>
      <el-form-item label="批注人姓名" prop="noterName">
        <el-input v-model="dataForm.noterName" placeholder="批注人姓名"></el-input>
      </el-form-item>
      <el-form-item label="课件类型：COURSE_WARE_PPT(课件);TECH_VIDEO(说课视频);RECORD_VIDEO(实录视频视频);MAKE_VIDEO(实录视频)" prop="type">
        <el-input v-model="dataForm.type"
                  placeholder="课件类型：COURSE_WARE_PPT(课件);TECH_VIDEO(说课视频);RECORD_VIDEO(实录视频视频);MAKE_VIDEO(实录视频)"></el-input>
      </el-form-item>
      <el-form-item label="批注内容" prop="noteCount">
        <el-input v-model="dataForm.noteCount" placeholder="批注内容"></el-input>
      </el-form-item>
      <el-form-item label="批注文件(多的文件用; 分割)" prop="noteFiles">
        <el-input v-model="dataForm.noteFiles" placeholder="批注文件(多的文件用; 分割)"></el-input>
      </el-form-item>
      <el-form-item label="ppt/word 页码" prop="pageNum">
        <el-input v-model="dataForm.pageNum" placeholder="ppt/word 页码"></el-input>
      </el-form-item>
      <el-form-item label="video:时分秒 如: 01:01:01" prop="videoTime">
        <el-input v-model="dataForm.videoTime" placeholder="video:时分秒 如: 01:01:01"></el-input>
      </el-form-item>
      <el-form-item label="机构id" prop="orgId">
        <el-input v-model="dataForm.orgId" placeholder="机构id"></el-input>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          ad: 0,
          id: '',
          userId: '',
          courseId: '',
          noterName: '',
          type: '',
          noteCount: '',
          noteFiles: '',
          pageNum: '',
          videoTime: '',
          orgId: '',
          creator: '',
          updater: '',
          createTime: '',
          updateTime: '',
          deleted: ''
        },
        dataRule: {
          id: [
            {required: true, message: 'ID不能为空', trigger: 'blur'}
          ],
          userId: [
            {required: true, message: '用户id(老师/学生)不能为空', trigger: 'blur'}
          ],
          courseId: [
            {required: true, message: '课程id不能为空', trigger: 'blur'}
          ],
          noterName: [
            {required: true, message: '批注人姓名不能为空', trigger: 'blur'}
          ],
          type: [
            {
              required: true,
              message: '课件类型：COURSE_WARE_PPT(课件);TECH_VIDEO(说课视频);RECORD_VIDEO(实录视频视频);MAKE_VIDEO(实录视频)不能为空',
              trigger: 'blur'
            }
          ],
          noteCount: [
            {required: true, message: '批注内容不能为空', trigger: 'blur'}
          ],
          noteFiles: [
            {required: true, message: '批注文件(多的文件用; 分割)不能为空', trigger: 'blur'}
          ],
          pageNum: [
            {required: true, message: 'ppt/word 页码不能为空', trigger: 'blur'}
          ],
          videoTime: [
            {required: true, message: 'video:时分秒 如: 01:01:01不能为空', trigger: 'blur'}
          ],
          orgId: [
            {required: true, message: '机构id不能为空', trigger: 'blur'}
          ],
          creator: [
            {required: true, message: '创建人不能为空', trigger: 'blur'}
          ],
          updater: [
            {required: true, message: '修改人不能为空', trigger: 'blur'}
          ],
          createTime: [
            {required: true, message: '创建时间不能为空', trigger: 'blur'}
          ],
          updateTime: [
            {required: true, message: '修改时间不能为空', trigger: 'blur'}
          ],
          deleted: [
            {required: true, message: '正常:0 ;删除:-1不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.ad = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.ad) {
            this.$http({
              url: this.$http.adornUrl(`/course/note/info/${this.dataForm.ad}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.id = data.courseNote.id
                this.dataForm.userId = data.courseNote.userId
                this.dataForm.courseId = data.courseNote.courseId
                this.dataForm.noterName = data.courseNote.noterName
                this.dataForm.type = data.courseNote.type
                this.dataForm.noteCount = data.courseNote.noteCount
                this.dataForm.noteFiles = data.courseNote.noteFiles
                this.dataForm.pageNum = data.courseNote.pageNum
                this.dataForm.videoTime = data.courseNote.videoTime
                this.dataForm.orgId = data.courseNote.orgId
                this.dataForm.creator = data.courseNote.creator
                this.dataForm.updater = data.courseNote.updater
                this.dataForm.createTime = data.courseNote.createTime
                this.dataForm.updateTime = data.courseNote.updateTime
                this.dataForm.deleted = data.courseNote.deleted
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl(`/course/note/${!this.dataForm.id ? 'save' : 'update'}`),
              method: `${!this.dataForm.id ? 'put' : 'post'}`,
              data: this.$http.adornData({
                'ad': this.dataForm.ad || undefined,
                'id': this.dataForm.id,
                'userId': this.dataForm.userId,
                'courseId': this.dataForm.courseId,
                'noterName': this.dataForm.noterName,
                'type': this.dataForm.type,
                'noteCount': this.dataForm.noteCount,
                'noteFiles': this.dataForm.noteFiles,
                'pageNum': this.dataForm.pageNum,
                'videoTime': this.dataForm.videoTime,
                'orgId': this.dataForm.orgId,
                'creator': this.dataForm.creator,
                'updater': this.dataForm.updater,
                'createTime': this.dataForm.createTime,
                'updateTime': this.dataForm.updateTime,
                'deleted': this.dataForm.deleted
              })
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
